import { render, staticRenderFns } from "./emojis.vue?vue&type=template&id=b663b3ea&scoped=true&"
import script from "./emojis.vue?vue&type=script&lang=js&"
export * from "./emojis.vue?vue&type=script&lang=js&"
import style0 from "./emojis.vue?vue&type=style&index=0&id=b663b3ea&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b663b3ea",
  null
  
)

export default component.exports